import { IClientConfigs, IVector3 } from '~/shared';

export interface HouseDraft {
	houseClass: string;
	price: string;
	interiorId: string;
	marker: string;
	spawn: string;
	parkingSlots: string;
}

export const emptyHouseDraft = (): HouseDraft => ({
	houseClass: '',
	price: '',
	interiorId: '',
	marker: '',
	spawn: '',
	parkingSlots: '',
});

export const formatHousePosition = ({ x, y, z }: IVector3): string =>
	[x, y, z].map((value) => value.toFixed(3)).join(', ');

const validPosition = (value: string): boolean => {
	const parts = value.split(',');
	return (
		parts.length === 3 &&
		parts.every((part) => part.trim() !== '' && Number.isFinite(Number(part)))
	);
};

export function normalizeHousePosition(value: string): string {
	if (!validPosition(value)) return value;
	const [x, y, z] = value.split(',').map(Number);
	return formatHousePosition({ x, y, z });
}

export function getHouseDraftErrors(
	draft: HouseDraft,
	config?: IClientConfigs['houses'],
): string[] {
	const errors: string[] = [];
	if (!config?.interiors.some((item) => item.id === draft.interiorId))
		errors.push('Выберите интерьер.');
	if (!config?.classes.some((item) => item.id === draft.houseClass))
		errors.push('Выберите класс дома.');
	if (
		!/^\d+$/.test(draft.price) ||
		!Number.isSafeInteger(Number(draft.price)) ||
		Number(draft.price) <= 0
	)
		errors.push('Укажите цену: целое число больше нуля.');
	if (!validPosition(draft.marker)) errors.push('Отметьте вход в дом.');
	if (!validPosition(draft.spawn))
		errors.push('Отметьте место выхода из дома.');
	if (
		!/^\d+$/.test(draft.parkingSlots) ||
		!Number.isSafeInteger(Number(draft.parkingSlots))
	)
		errors.push('Укажите число парковочных мест: ноль или больше.');
	return errors;
}

export function formatHouseLocationRow(draft: HouseDraft): string {
	// houses.xlsx / locations: B:G. Column A (id) is filled manually.
	return [
		draft.houseClass,
		Number(draft.price),
		draft.interiorId,
		...[draft.marker, draft.spawn].map(normalizeHousePosition),
		Number(draft.parkingSlots),
	].join('\t');
}
